import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { preloadSpaceRestrictionCheck } from '@confluence/restrictions/entry-points/preloadSpaceRestrictionCheck.ts';

export const preloadCommonDataForRouteWithSpaceKey = async (spaceKey: string): Promise<any> => {
	return waitForAllReturnWhenError([preloadSpaceRestrictionCheck(spaceKey)]);
};
